import PropTypes from 'prop-types';

import { userPreferencesQueryKeys } from 'lib/queryKeys';

import {
  getUserWebpushPreferences,
  postUserWebpushPreference,
} from 'services/permissions';

import Settings from './Settings';
import SwitchGroupSkeleton from './SwitchGroup/Skeleton';

const SETTINGS = [
  {
    title: 'Recebimento de notificações no navegador',
    options: [
      {
        id: 'webpush_product',
        label: 'Nova oferta da Lista de Desejos',
      },
      {
        id: 'webpush_hidden',
        label: 'Receber recomendações de ofertas',
      },
      {
        id: 'webpush_comment',
        label: 'Me marcarem em um comentário',
      },
      {
        id: 'webpush_blog',
        label: 'Novas postagens no blog',
      },
    ],
  },
];

const NotificationSettings = ({ className }) => (
  <Settings
    className={className}
    mutationFn={postUserWebpushPreference}
    queryFn={getUserWebpushPreferences}
    queryKey={userPreferencesQueryKeys.webpush()}
    settings={SETTINGS}
    skeleton={SwitchGroupSkeleton}
    subscribedKey="webpushSubscribed"
    title="Notificações"
    unsubscribedKey="webpushUnsubscribed"
  />
);

NotificationSettings.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default NotificationSettings;
